import { TOGGLECONTENT } from "./actionsTypes"

const initialStat = {
    ishideContent: false,
};

export default function reducer(state = initialStat, action) {
    switch (action.type) {
        case TOGGLECONTENT:
            return {
                ...state,
                ishideContent: action.ishideContent,
            }
        default:
            return state;
    }
}






